import { webServerHostUrl } from '../../utilities/url_util';
import { getJournalDescription } from '../../apis/metaData';
import {
  POI_BANK_NEXT_STATUS_SUCCESS,
  POI_BANK_NEXT_STATUS_NO_RESULTS,
  JOURNALS_STATUS_PRIVATE,
} from '../../utilities/constants';
import { journalMetaTagString } from '../../utilities/meta_tags_util';
import { checkImgType } from '../../utilities/image_util';
import { getLanguageByRank } from '../../utilities/language';

const getSecretId = () => process.env.SECRET_ID_FOR_META_TAGS;

async function loadData(urlPath, language, query, params, headers) {
  if (!params) {
    return {
      metaData: null,
    };
  }

  const { userid, journalId } = params;
  if (!userid || !journalId) {
    return {
      metaData: null,
    };
  }
  const secretId = getSecretId();
  const logoUrl = 'https://assets.funliday.com/logo/logo_funliday.png';

  try {
    const response = await getJournalDescription(userid, journalId, secretId);
    const { data } = response;

    if (data.code === POI_BANK_NEXT_STATUS_NO_RESULTS) {
      return {
        notFound: true,
      };
    }
    // private
    if (data.code === JOURNALS_STATUS_PRIVATE) {
      return {
        metaData: "<meta name='robots' content='noindex' />",
      };
    }

    if (data.code !== POI_BANK_NEXT_STATUS_SUCCESS) {
      return {
        metaData: null,
      };
    }

    const {
      data: {
        journal: {
          title,
          description,
          nickname,
          userid: realUserid,
          published_at,
          updated_at,
          noindex,
          cover,
          language: authorLanguage,
        },
      },
    } = data;

    const canonicalUrl = `${webServerHostUrl()}${realUserid}/journals/${journalId}`;

    if (userid !== realUserid) {
      return {
        redirect: {
          status: 301,
          url: canonicalUrl,
        },
      };
    }
    const coverUrl = checkImgType({ data: cover, isSSR: true });
    const size = { width: cover.width, height: cover.height };
    const urlScheme = `funliday://journals/${realUserid}/${journalId}`;

    const schemaBlogPosting = {
      '@context': 'https://schema.org',
      '@type': 'BlogPosting',
      mainEntityOfPage: {
        '@type': 'WebPage',
        '@id': canonicalUrl,
      },
      headline: title,
      image: [coverUrl],
      datePublished: published_at,
      dateModified: updated_at,
      author: {
        '@type': 'Person',
        name: nickname,
      },
      publisher: {
        '@type': 'Organization',
        name: 'Funliday',
        logo: {
          '@type': 'ImageObject',
          url: logoUrl,
        },
      },
      description,
    };
    const metaLanguage = getLanguageByRank(
      query.hl,
      authorLanguage,
      headers['accept-language'],
    );
    let metaData = journalMetaTagString({
      urlPath,
      title,
      images: [coverUrl],
      description,
      language: metaLanguage,
      size,
      nickname,
      noindex,
    });
    const schemaBreadcrumb = {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: [
        {
          '@type': 'ListItem',
          position: 1,
          name: 'Funliday',
          item: 'https://www.funliday.com',
        },
        {
          '@type': 'ListItem',
          position: 2,
          name: realUserid,
          item: `https://www.funliday.com/${realUserid}`,
        },
        {
          '@type': 'ListItem',
          position: 3,
          name: '遊記',
          item: `https://www.funliday.com/${realUserid}/journals`,
        },
        {
          '@type': 'ListItem',
          position: 4,
          name: title,
          item: canonicalUrl,
        },
      ],
    };

    const htmlLang = authorLanguage || 'en';
    const fbAppLink = '';
    metaData += `
      ${fbAppLink}
      <!-- for google search results -->
      <script type="application/ld+json">
        ${JSON.stringify(schemaBlogPosting, null, 2)}
      </script>
      <script type="application/ld+json">
        ${JSON.stringify(schemaBreadcrumb, null, 2)}
      </script>
      <!-- /for google search results -->
    `;
    // console.log(metaData);
    return {
      metaData,
      htmlLang,
    };
  } catch (error) {
    console.log(error);
    return {
      metaData: null,
    };
  }
}

export default loadData;
